import React, { useState, useRef, useEffect, useMemo } from 'react';
import { BiUpload } from 'react-icons/bi';
import api from '../../Services/api';
import axios from 'axios';
import { COLORS } from '../colors';
import DatePicker from 'react-datepicker';
import '../EditableCard.css';
import { Snackbar } from '@mui/material';
import SnackbarContent from '@mui/material/SnackbarContent';
import { MdFileOpen } from "react-icons/md";
import { FaFileDownload } from "react-icons/fa";
import { useLocation } from 'react-router-dom';
import MonthlyReport from '../../Component/Client/ClientMonthlyReport'

const hardcodedDueDates = {
  "AccidentalReportSubmission": "Every Month before 5th",
  "TheGoodsAndServiceTaxOutwardSupplies": "Every Month before 11th",
  "TheGoodsAndServiceTaxSummaryReturn": "Every Month Before 20th",
  "EsicMonthlyContributionHistoryAndChallans": "Every Month Before 15th",
  "EpfoEcrAndRemittanceConfirmationChallan": "Every Month Before 15th",
  "EpfoPaidChallanCopyAndDate": "Every Month Before 15th",
  "EpfoCopyOfReturnToInternationalWorkers": "Every Month Before 20th",
  "LabourWelfareFund": "Every Month Before 5th",
  "TaxOnProfessions": "Every Month Before 5th",

  "FactoryHalfYearReturn": "Before 31st July",
  "PressureVesselReport": "Every Six Months",
  "FireSafetyTraining": "Every Six Months",
  "EsicHalfYearlyReturnsMaintainHalfYearlyReturn":"Half Yearly",
  "FactoryAnnualReturns": "Before 31st January",
  "HazardousWasteAnnualReturns": "30th June",
  "EnvironmentalAuditReport": "31st March",
  "LabourWelfareFundFormD": "Before 15th & 31st January",
  "ClraRcAnnualReturns": "Before 31st January",
  "PaymentOfBonusActReturnAnnexure": "Before 31st December",
  "PaymentOfBonusActReturnAcknowledgementCopy":'Before 31st December'
};

const titles = [
  "TheGoodsAndServiceTaxOutwardSupplies",
  "TheGoodsAndServiceTaxSummaryReturn",
  "FactoryHalfYearReturn",
  "FactoryAnnualReturns",
  "FireSafetyTraining",
  "EnvironmentalAuditReport",
  "DirectGreenhouseGasGHGEmissions",
  "IndirectGHGEmissions",
  "AllOtherIndirectEmissionsInTheValueChain",
  "TotalEnergyConsumedRenewableSources",
  "TotalEnergyConsumedNonRenewableSources",
  "WaterConsumed",
  "TotalAmountOfwasteGenerated",
  "CapExOnGreenInitiatives",
  "PenaltiesAndFinesPaidDueToEnvironmentalIssues",
  "OpexOnGreenInitiatives",
  "CSRBudgetAsAPercentOfProfits",
  "PercentOfCSRBudgetUtilized",
  "HazardousWasteAnnualReturns",
  "PressureVesselReport",
  "EpfoEcrAndRemittanceConfirmationChallan",
  "EpfoPaidChallanCopyAndDate",
  "EpfoCopyOfReturnToInternationalWorkers",
  "EsicMonthlyContributionHistoryAndChallans",
  "EsicHalfYearlyReturnsMaintainHalfYearlyReturn",
  "TaxOnProfessions",
  "LabourWelfareFund",
  "LabourWelfareFundFormD",
  "ClraRcAnnualReturns",
  "PaymentOfBonusActReturnAnnexure",
  "PaymentOfBonusActReturnAcknowledgementCopy",
  "EmployeeTurnoverRate",
  "AverageHoursOfTrainingPerEmployee",
  "GenderPayGap",
  "WorkforceDemographics",
  "PercentageOfIndependentDirectorsOnTheBoard",
  "BoardDiversity",
  "TotalEmployeeCompensationAndBenefits",
  "TotalExpenditureOnEmployeeTraining",
  "CapexOnEmployeeWelfareInitiatives",
  "AnnualReturnsPOSHAct2013",
  "PendingCasesPOSHAct2013",
  "AccidentReportSubmission",
  "PendingNoticeFromGovtBodies",
  "NetZeroTarget",
  "WomenInWorkforce",
  "NumberOfWomenDirectorsOnTheBoard",
  "ShareholdersComplaintsResolved",
  "WhistleblowerComplaintsResolved",
  "TotalRecordableIncidentRate",
  "AnnualGeneralBodyMeeting",
  "BoardMeetings",
  "ReviewByAuditCommittee",
  "PercentageOfEmployeessignedCOBEC",
  "BoardReviewOfESGPerformance",
  "CSRProjectsCompletedAndOngoing",
  "ReviewByRiskCommittee",
 


];

const months = [
  { name: "JANUARY", value: "01" },
  { name: "FEBRUARY", value: "02" },
  { name: "MARCH", value: "03" },
  { name: "APRIL", value: "04" },
  { name: "MAY", value: "05" },
  { name: "JUNE", value: "06" },
  { name: "JULY", value: "07" },
  { name: "AUGUST", value: "08" },
  { name: "SEPTEMBER", value: "09" },
  { name: "OCTOBER", value: "10" },
  { name: "NOVEMBER", value: "11" },
  { name: "DECEMBER", value: "12" }
];

const currentYear = new Date().getFullYear();
const years = Array.from({ length: currentYear - 2020 + 1 }, (x, i) => 2020 + i);
const today = new Date();

const formatTitle = (title) => title.replace(/([a-z])([A-Z])/g, '$1 $2');

const MonthlyDataClient = () => {
  const location = useLocation();
  // incoming state from chart / other page
  const { filter: locationFilter, month: locationMonth, year: locationYear } = location.state || {};
       const [filter, setFilter] = useState("All");

  const [loading, setLoading] = useState(true);
  const [saveStates, setSaveStates] = useState({});
  const [selectedDate, setSelectedDate] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
  const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');
  const [uploadStates, setUploadStates] = useState({});
  // initialize month/year with incoming values (if present)
  const [selectedYear, setSelectedYear] = useState(locationYear ?? null);
  const [selectedMonth, setSelectedMonth] = useState(locationMonth ?? '');
  const [activeFilter, setActiveFilter] = useState(locationFilter ?? ''); // <--- active filter applied locally
  const client = JSON.parse(sessionStorage.getItem('user'));
  const id = client?.id;
      const [showModal, setShowModal] = useState(false);
  
  const fileInputRefs = useRef({});
      const handleShow = () => setShowModal(true);  // Show modal
    const handleClose = () => setShowModal(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 600);
    return () => clearTimeout(timer);
  }, []);

  // fetch whenever id/month/year changes
  useEffect(() => {
    // only fetch when month is non-empty (same as your previous condition)
    if (id && selectedMonth !== null && selectedYear !== null && selectedMonth !== '') {
      fetchData(id, selectedMonth, selectedYear);
    }
  }, [id, selectedMonth, selectedYear]);

  const fetchData = async (id, selectedMonth, selectedYear) => {
    try {
      const response = await api.client.getEstablishmentMonthlyData(id, selectedMonth, selectedYear);
      if (response.status === 200) {
        const data = response.data.data || {};
        const initialState = {};
        const initialSaveState = {};
        titles.forEach(title => {
          initialState[title] = {
            file: null,
                    Category: data[title]?.Category || '',
            
            frequency: data[title]?.frequency || '',
            DueDate: hardcodedDueDates[title],
            fileUrl: data[title]?.fileUrl || '',
            uploaded: !!data[title]?.fileUrl,
            validation: data[title]?.validation,
            uploading: false,
            na: data[title]?.na || false,
            AssessorRemark: data[title]?.AssessorRemark || '',
            clientRemark: data[title]?.clientRemark || ''
          };
          // A row is considered saved if fileUrl exists OR na is true OR validation already accepted/rejected
          const validation = data[title]?.validation;
          initialSaveState[title] = !!data[title]?.fileUrl || !!data[title]?.na || (validation === 2 || validation === 3);
        });

        setSelectedDate(response.data.data.complianceFiledDate || '');
        setUploadStates(initialState);
        setSaveStates(initialSaveState);
      } else {
        // non-200 -> clear and show error
        setUploadStates({});
        setSelectedDate('');
        setSaveStates({});
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data?.message || 'Error fetching data');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setUploadStates({});
      setSelectedDate('');
      setSaveStates({});
      setErrorSnackbarOpen(true);
      setSnackbarErrorMessage('Error fetching data');
    }
  };

  const handleFileChange = (e, title) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploadStates(prev => ({
      ...prev,
      [title]: {
        ...prev[title],
        file,
        fileUrl: file.name,
        uploaded: false,
        uploading: false
      }
    }));
    setSaveStates(prev => ({ ...prev, [title]: false }));
  };

  const handleDateChange = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    setSelectedDate(formattedDate);
  };

  const handleNotApplicableChange = (title) => {
    setUploadStates(prev => ({
      ...prev,
      [title]: {
        ...prev[title],
        na: !prev[title].na,
        file: null,
        fileUrl: '',
        uploaded: false,
        clientRemark: ''
      }
    }));

    setSaveStates(prev => ({ ...prev, [title]: false }));

    if (fileInputRefs.current[title]) fileInputRefs.current[title].value = '';
  };

  const handleUpload = async (title) => {
    const state = uploadStates[title];
    if (!state?.file) return;

    setUploadStates(prev => ({ ...prev, [title]: { ...prev[title], uploading: true } }));

    try {
      const formData = new FormData();
      formData.append('file', state.file);
      formData.append('fieldName', title);
      formData.append('companyId', id);
        formData.append('month',selectedMonth)
      formData.append('year',selectedYear)
    

      const response = await axios.put(`https://www.grcpulse.in/api/EstMonthlyData/upload-file`, formData);

      if (response.status === 200) {
        setUploadStates(prev => ({
          ...prev,
          [title]: {
            ...prev[title],
            uploading: false,
            uploaded: true,
            fileUrl: response.data.data,
            clientRemark: ''
          }
        }));
        setSnackbarOpen(true);
        setSnackbarMessage("File uploaded successfully.");
      } else if (response.status === 413) {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage("File size should be below 6MB");
         setUploadStates(prev => ({
          ...prev,
          [title]: {
            ...prev[title],
            uploading: false,
            uploaded: false,
            fileUrl:'',
            clientRemark: ''
          }
        }));
      } else {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage("Error occurred while uploading, try again.");
      }
    } catch (error) {
      console.error(error);
      setUploadStates(prev => ({
        ...prev,
        [title]: { ...prev[title], file: null, fileUrl: '', uploading: false, uploaded: false }
      }));
      setErrorSnackbarOpen(true);
      setSnackbarErrorMessage("Upload failed");
    }
  };

  const handleSave = async (title) => {
    const state = uploadStates[title] || {};

    if (!selectedMonth || !selectedYear) {
      setErrorSnackbarOpen(true);
      setSnackbarErrorMessage('Please select month and year');
      return;
    }
    if (!selectedDate) {
      setErrorSnackbarOpen(true);
      setSnackbarErrorMessage('Please select compliance file data');
      return;
    }
    if (!state.na && (!state.fileUrl || !state.uploaded)) {
      setErrorSnackbarOpen(true);
      setSnackbarErrorMessage('Please select "Not Applicable" or upload a file before saving');
      return;
    }

    const payload = {
      companyId: id,
      month: selectedMonth,
      year: selectedYear,
      complianceFiledDate: selectedDate,
      [title]: {
        frequency: state.frequency,
        critical: state.critical,
        risk: state.risk,
        DueDate: state.DueDate,
        validation: 1,
        fileUrl: state.uploaded ? state.fileUrl : '',
        clientRemark: state.clientRemark || '',
        AsssessorRemark: state.AssessorRemark || '',
        na: state.na
      }
    };

    try {
      const response = await api.client.updateEstablishmentMonthlyData(payload);
      if (response.status === 200) {
        const updatedData = response.data.data[title];
        setUploadStates(prev => ({
          ...prev,
          [title]: {
            ...prev[title],
            file: null,
            fileUrl: updatedData?.fileUrl || '',
            uploaded: !!updatedData?.fileUrl,
            validation: updatedData?.validation || 0,
            AssessorRemark: updatedData?.AssessorRemark || '',
            clientRemark: updatedData?.clientRemark || '',
            na: updatedData?.na || false
          }
        }));
        setSaveStates(prev => ({ ...prev, [title]: true }));
        setSnackbarOpen(true);
        setSnackbarMessage(response.data.message);
      
     try {
        // console.log('Calling assessorToMail with payload:', payload);
        const response = await api.client.assessorToMail(payload);

        if (response.status === 200) {
          setTimeout(()=>{
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          },2000)
        }
        else if(response.status === 400){
          setTimeout(()=>{
          setErrorSnackbarOpen(true);
          setSnackbarErrorMessage(response.data.message);
          },2000)
        }
         else if(response.status === 404){
          setTimeout(()=>{
          setErrorSnackbarOpen(true);
          setSnackbarErrorMessage(response.data.message);
          },2000)
        }
         else if(response.status === 500){
          setTimeout(()=>{
          setErrorSnackbarOpen(true);
          setSnackbarErrorMessage(response.data.message);
          },2000)
        } else {
          setTimeout(()=>{
          setErrorSnackbarOpen(true);
          setSnackbarErrorMessage(response.data.message);
          },2000)
        }
      } catch (emailErr) {
        console.error('assessorToMail error:', emailErr);
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(emailErr?.response?.data?.message);
      }
    }
       else {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data?.message || 'Error saving');
      }
    } catch (error) {
      console.error('Error saving monthly data:', error);
      setErrorSnackbarOpen(true);
      setSnackbarErrorMessage('Error saving monthly data');
    }
  };

  const handleViewDocument = (fileUrl) => {
    window.open(`https://docs.google.com/gview?url=${fileUrl}&embedded=true`, '_blank');
  };


  const getBackgroundColor = (validation) => {
    
    switch (validation) {
      case 1: return COLORS.bggray;
      case 2: return 'lightgreen';
      case 3: return 'lightcoral';
      default: return 'transparent';
    }
  };

 const filteredTitles = useMemo(() => { 
  if (!activeFilter) return []; const norm = String(activeFilter).toLowerCase().trim(); let neededValidation = null; if (norm === 'accepted' || norm === 'accept') neededValidation = 2; else if (norm === 'rejected' || norm === 'reject') neededValidation = 3; else if (norm === 'under review' || norm === 'underreview' || norm === 'under_review' || norm === 'underreview') neededValidation = 1; if (neededValidation === null) return []; return titles.filter(title => { const st = uploadStates[title]; return st && st.validation === neededValidation; }); }, [uploadStates, activeFilter]);




  // When user changes month/year on this page, remove the incoming filter and show all rows for the new period
  const handleMonthChange = (value) => {
    setSelectedMonth(value);
    // clearing the activeFilter ensures all rows for new month/year are shown (no filter)
    setActiveFilter('');
  };

  const handleYearChange = (value) => {
    setSelectedYear(value);
    setActiveFilter('');
  };

  return (
    <>
      {loading ? (
        <div className="d-flex flex-row align-items-center justify-content-center" style={{ marginTop: '80px' }}>
          <h3>Loading</h3>
          <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem', marginLeft: '10px' }} role="status" />
          <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem', marginLeft: '10px' }} role="status" />
          <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem', marginLeft: '10px' }} role="status" />
        </div>
      ) : (
        <section>
          <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={snackbarOpen} autoHideDuration={4000} onClose={() => setSnackbarOpen(false)} sx={{ marginTop: '2.9%', marginRight: '7%' }}>
            <SnackbarContent style={{ backgroundColor: "green" }} message={snackbarMessage} />
          </Snackbar>
          <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={errorSnackbarOpen} autoHideDuration={5000} onClose={() => setErrorSnackbarOpen(false)} sx={{ marginTop: '2.9%', marginRight: '7%' }}>
            <SnackbarContent style={{ backgroundColor: "red" }} message={snackbarErrorMessage} />
          </Snackbar>

          <div className="d-grid">
            <div className='mx-4'>
              <div className='d-flex pb-3' style={{ justifyContent: 'space-between' }}>
                <div className="mt-3" style={{ letterSpacing: '1px' }}>
                  <div style={{ backgroundColor: COLORS.bggray, width: '15px', height: '15px', display: 'inline-block', marginRight: '4px', marginLeft: '8px', borderRadius: '50%' }} />
                  <span style={{ fontSize: '14px' }}>Under review</span>
                  <div className="vr  mx-3" />
                  <div style={{ backgroundColor: COLORS.success, width: '15px', height: '15px', display: 'inline-block', marginRight: '4px', borderRadius: '50%' }} />
                  <span style={{ fontSize: '14px' }}>Accepted</span>
                  <div className="vr mx-3" />
                  <div style={{ backgroundColor: COLORS.danger, width: '15px', height: '15px', display: 'inline-block', marginRight: '4px', borderRadius: '50%' }} />
                  <span style={{ fontSize: '14px' }}>Rejected</span>
                </div>
              </div>

              <div className="mb-3 d-flex float-end">
    
                <select style={{ border: '1px solid lightgray', borderRadius: '5px', cursor: 'pointer' }} className='mx-1 p-1' value={selectedMonth || ''} onChange={(e) => handleMonthChange(e.target.value)}>
                  <option value="" disabled>Select Month</option>
                  {months.map((m) => <option key={m.value} value={m.value}>{m.name}</option>)}
                </select>

                <select style={{ border: '1px solid lightgray', borderRadius: '5px', cursor: 'pointer' }} className='mx-1 p-1' value={selectedYear || ''} onChange={(e) => handleYearChange(e.target.value)}>
                  <option value="" disabled>Select Year</option>
                  {years.map((y) => <option key={y} value={y}>{y}</option>)}
                </select>

                <div className="d-flex mx-2 float-end p-1" style={{ position: 'relative', zIndex: 9999, width: 'auto', border: '1px solid lightgray', borderRadius: '4px', width: '200px', cursor: 'pointer' }}>
                  <DatePicker selected={selectedDate ? new Date(selectedDate) : null} onChange={handleDateChange} disabled={!selectedYear && !selectedMonth} placeholderText="Compliance filling date" dateFormat="dd/MM/yyyy" filterDate={(date) => date.toDateString() === today.toDateString()} />
                </div>
              </div>
            </div>

            <div style={{ minHeight: '370px', maxHeight: "380px", overflowY: "auto" }}>
              <table className="mt-0 pt-0">
                 
                                {selectedDate && (
                      
                                    <button className='flex flex-row gap-1 p-3 items-center text-sm text-danger' onClick={handleShow}>
                <MdFileOpen className="text-xl text-danger" /> View Report
                                    </button>
                                  
                           
                                )}
                <thead className='position-sticky top-0' style={{ zIndex: 10 }}>
                  <tr className='text-white bg-dark'>
                    <th>Name of Doc</th>
                    <th>Category</th>

                    <th>Frequency</th>
                      <th>Due Date</th>
                    <th>Upload File</th>
                    <th>Establishment Remark</th>
                    <th>Action</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {/* If there was an incoming filter and no titles match -> show friendly message */}
                  {activeFilter && filteredTitles.length === 0 ? (
                    <tr>
                      <td colSpan={6} className="text-center text-muted">No rows match the selected filter for this month/year.</td>
                    </tr>
                  ) : (
                    // If activeFilter exists show filteredTitles otherwise show all titles
                   (activeFilter ? filteredTitles : titles).map((title, idx) => {
                      const state = uploadStates[title] || {};
                      const validationText = state.validation === 1 ? "Under Review" : state.validation === 2 ? "Accepted" : state.validation === 3 ? "Rejected" : "Not Uploaded";

                      return (
                        <tr key={idx} style={{ backgroundColor: getBackgroundColor(state.validation) }}>
                          <td>{formatTitle(title)}</td>
                          <td className='text-secondary'>{state.Category || ''}</td>

                          <td>{state.frequency || ''}</td>
                           <td>{state.DueDate || '-'}</td>

                          <td className="d-flex justify-content-between">
                            <section className='d-flex flex-col justify-content-center align-items-center'>
                              <div className='w-full'>
                                <input type="text" readOnly disabled={state.na} className="border rounded p-2 mb-2 w-full" value={state.fileUrl || ''} placeholder="No file selected" />

                                <label className={`w-full border p-2 border-primary rounded text-blue-600 mb-1 flex flex-col items-center ${!state.na && selectedMonth && selectedYear && selectedDate ? 'cursor-pointer' : 'cursor-default'}`}
                                  onClick={(e) => { if (state.na || !selectedMonth || !selectedYear || !selectedDate) e.preventDefault(); }}>
                                  <BiUpload style={{ fontSize: '18px' }} />
                                  <input type="file" className="hidden" disabled={state.na} ref={(el) => (fileInputRefs.current[title] = el)} onChange={(e) => handleFileChange(e, title)} />
                                </label>

                                <button disabled={!state.file || state.uploading || state.uploaded} onClick={() => handleUpload(title)} className="mt-2 p-2 w-full btn btn-sm btn-light" style={{ border: '1px solid gray' }}>
                                  {state.uploaded ? 'Uploaded' : state.uploading ? 'Uploading...' : 'Upload'}
                                </button>
                              </div>

                              <div className='mt-2'>
                                {state.fileUrl && state.uploaded && (
                                  <div className="d-flex gap-3 align-items-center">
                                    <button className="flex flex-col items-center text-sm text-green-700 border-0 bg-transparent" onClick={() => handleViewDocument(state.fileUrl)}>
                                      <MdFileOpen className="text-xl text-success" /> View
                                    </button>
                                    <a download className="flex flex-col items-center text-sm text-blue-700 border-0 bg-transparent" href={state.fileUrl}>
                                      <FaFileDownload className="text-xl text-primary" />Download
                                    </a>
                                  </div>
                                )}
                              </div>
                            </section>

                            <div className="m-4">
                              <input type="checkbox" disabled={!selectedMonth || !selectedYear || !selectedDate} checked={state.na} onChange={() => handleNotApplicableChange(title)} />
                              <div className="text-sm">Not Applicable</div>
                            </div>
                          </td>

                          <td>
                            <textarea rows="3" type="text" placeholder='Enter your remarks here' className="border border-secondary p-1 w-full" value={state.clientRemark || ''} onChange={(e) => {
                              setUploadStates(prev => ({ ...prev, [title]: { ...prev[title], clientRemark: e.target.value } }));
                              setSaveStates(prev => ({ ...prev, [title]: false }));
                            }} />
                          </td>

                          <td>
                            <button disabled={saveStates[title] || (state.validation === 3 && !state.AssessorRemark)} onClick={() => handleSave(title)} className='btn btn-outline-dark btn-md'>
                              {saveStates[title] ? 'Saved' : 'Save'}
                            </button>
                          </td>

                          <td className='text-center align-center'>
                            <div className="text-center">{validationText}</div>
                            {state.AssessorRemark && (
                              <div style={{ overflow: 'auto', width: '200px', height: '100px' }}>
                                <p className='text-dark'> Assessor Remark: {state.AssessorRemark}</p>
                              </div>
                            )}
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>

            </div>
 
        </div>

            <MonthlyReport showModal={showModal} onClose={handleClose} selectedMonth={selectedMonth}
                selectedYear={selectedYear} />
        </section>
      )}
                 
    </>
  );
};

export default MonthlyDataClient;
